module.exports = __webpack_public_path__ + "static/media/girl-face.c70fae20.svg";